import React from "react"
import WindowCard from "../../../components/ui/window-card/window-card"

const KEY_LABELS = {
	utm_source: "Source",
	utm_medium: "Medium",
	utm_campaign: "Campaign",
	utm_term: "Term",
	utm_content: "Content",
	gclid: "Google click ID",
	fbclid: "Facebook click ID",
}

/**
 * Right-rail card showing where the enquiry came from
 */
export default function SourceCard({ inboundChannel, tracking = {}, site }) {
	const trackingKeys = Object.keys(tracking || {}).filter((k) => tracking[k])
	const hasContent = inboundChannel || site || trackingKeys.length > 0

	if (!hasContent) {
		return (
			<WindowCard title="Source">
				<div className="enquiry-card-body">
					<small className="no-value">No attribution data captured</small>
				</div>
			</WindowCard>
		)
	}

	return (
		<WindowCard title="Source">
			<div className="enquiry-card-body">
				{site && (
					<div className="enquiry-card-row">
						<span className="enquiry-card-label">Site</span>
						<span className="enquiry-card-value">{site}</span>
					</div>
				)}

				{inboundChannel && (
					<div className="enquiry-card-row">
						<span className="enquiry-card-label">Channel</span>
						<span className="enquiry-card-value">{inboundChannel}</span>
					</div>
				)}

				{trackingKeys.length > 0 && (
					<>
						{(site || inboundChannel) && <div className="enquiry-card-divider" />}
						{trackingKeys.map((key) => (
							<div className="enquiry-card-row" key={key}>
								<span className="enquiry-card-label">{KEY_LABELS[key] || key}</span>
								<span className="enquiry-card-value">{tracking[key]}</span>
							</div>
						))}
					</>
				)}
			</div>
		</WindowCard>
	)
}
